// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__99sXk","shimmer":"Skeleton_shimmer__qFx_9"};